import classNames from 'classnames';
import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import HelpIcon from 'ui-library/icons/HelpIcon';
export interface FieldTableHeaderProps {
  // isDisabled hides the add button and the table delete button
  isDisabled?: boolean;
  onAddField?: (() => void) | null;
  onAddToolTip?: string;
  toolTipIcon?: BenchlingIconName;
  shouldShowDefinition?: boolean;
  shouldShowIsParentLink?: boolean;
  shouldShowIsRequired?: boolean;
  shouldShowMultiSelect?: boolean;
  shouldShowValidations?: boolean;
  shouldShowIsIntegration?: boolean;
  shouldShowTooltip?: boolean;
  shouldShowWarehouseName?: boolean;
  subheader?: JSX.Element;
  title: string;
  helpText?: string;
  compactMode?: boolean;
}

function FieldTableHeader({
  isDisabled = false,
  onAddField,
  onAddToolTip,
  toolTipIcon,
  shouldShowDefinition = false,
  shouldShowIsParentLink = false,
  shouldShowIsRequired = false,
  shouldShowMultiSelect = true,
  shouldShowValidations = false,
  shouldShowIsIntegration = false,
  shouldShowTooltip = true,
  shouldShowWarehouseName = false,
  subheader,
  title,
  helpText,
  compactMode = false,
}: FieldTableHeaderProps): JSX.Element {
  const checkboxHeaderClassnames =
    'simpleDivTable-headerCell simpleDivTable-cell--narrow u-text-align-center';
  const defaultToolTipTitle = onAddField ? 'Add field to bottom' : 'Only one field may be added at a time';
  return (
    <div
      className={classNames('simpleDivTable-header', {
        'simpleDivTable-header--compact': compactMode,
      })}
    >
      <div className="simpleDivTable-headerCell simpleDivTable-header--title">
        {title}
        {helpText && (
          <Tooltip title={helpText}>
            <HelpIcon className="u-mini-spacing-left" />
          </Tooltip>
        )}
        {!isDisabled && (
          <Tooltip
            container="body"
            disabled={!shouldShowTooltip}
            placement={TooltipPlacement.TOP}
            title={onAddToolTip ?? defaultToolTipTitle}
          >
            <BenchlingIcon
              className={classNames('simpleDivTable-addButton', {
                'simpleDivTable-addButton--disabled': !onAddField,
              })}
              icon={toolTipIcon ?? 'compose'}
              onClick={onAddField || undefined}
            />
          </Tooltip>
        )}
      </div>
      {shouldShowWarehouseName && (
        <div className="simpleDivTable-headerCell">
          <div className="simpleDivTable-headerCell-contents">System name</div>
        </div>
      )}
      {shouldShowIsRequired && (
        <div className={checkboxHeaderClassnames}>
          <div className="simpleDivTable-headerCell-contents--centered">Required</div>
        </div>
      )}
      {shouldShowIsIntegration && (
        <div className={checkboxHeaderClassnames}>
          <div className="simpleDivTable-headerCell-contents--centered">Integration</div>
        </div>
      )}
      {shouldShowDefinition && shouldShowMultiSelect && (
        <div className={checkboxHeaderClassnames}>
          <div className="simpleDivTable-headerCell-contents--centered">Multi-select</div>
        </div>
      )}
      {/* TODO(BNCH-11113) Extract parent link awareness to TagSchemaFileSettings level */}
      {shouldShowIsParentLink && (
        <div className={checkboxHeaderClassnames}>
          <div className="simpleDivTable-headerCell-contents--centered">Parent link</div>
        </div>
      )}
      <div className="simpleDivTable-headerCell">
        <div className="simpleDivTable-headerCell-contents">
          {shouldShowDefinition && <div>Definition</div>}
          {subheader}
        </div>
      </div>
      {shouldShowValidations && (
        <div className="simpleDivTable-headerCell">
          <div className="simpleDivTable-headerCell-contents">Validation</div>
        </div>
      )}
    </div>
  );
}

export default FieldTableHeader;
